import appSettings from 'wanderu-config';
import {
    googleDataSelectors,
    fetchPlaceDetailsAction,
    fetchPlaceFromTextAction,
} from 'wanderu-ducks-google';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';

import {
    actions,
    namespace,
    reducer,
    selectors,
} from './base';

const logger = Logger.getLogger('wanderu-ducks-search:ducks:fetchSearchPlaces');

function fetchCity(opts) {
    return async (dispatch) => {
        if (opts.placeId) {
            return dispatch(fetchPlaceDetailsAction.fetch(opts.placeId));
        }

        return dispatch(fetchPlaceFromTextAction.fetch(opts));
    };
}

function _getTopPlaceId(state, opts) {
    const prediction = googleDataSelectors.selectTopPrediction(state, opts) || {};
    return prediction.placeId;
}

function _getPlaceId(state, opts) {
    if (opts.placeId) {
        return opts.placeId;
    }

    return _getTopPlaceId(state, opts);
}

function fetch(opts) {
    return async (dispatch, getState) => {
        let {
            originInput,
            destinationInput,
            originPlaceId,
            destinationPlaceId,
            locale,
        } = opts;

        const originOpts = {
            input: originInput,
            placeId: originPlaceId,
            locale,
        };
        const destinationOpts = {
            input: destinationInput,
            placeId: destinationPlaceId,
            locale,
        };

        dispatch(actions.startWork());
        let error;
        let meta;
        try {
            await Promise.all([
                dispatch(fetchCity(originOpts)),
                dispatch(fetchCity(destinationOpts)),
            ]);

            originPlaceId = _getPlaceId(getState(), originOpts);
            destinationPlaceId = _getPlaceId(getState(), destinationOpts);

            // TODO: I don't love returning data out of actions
            return {
                originPlaceId,
                destinationPlaceId,
            };
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('fetch', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });
            error = {
                code: ex.code,
                message: ex.message,
                name: ex.name,
            };
        } finally {
            dispatch(actions.endWork(meta, error));
        }
    };
}

const fetchSearchPlacesAction = {
    fetch,
    ...selectors,
};

export {
    fetchCity,
    fetchSearchPlacesAction,
};

export default {
    [namespace]: reducer,
};
